import React, { useRef, useState } from "react";
// import { Image } from "react-bootstrap";
// internal
import vision_img_1 from "assets/img/Main Images/Home/3d services.jpg";
import vision_img_2 from "assets/img/Main Images/Home/best graphic design services delhi.jpg";
import vision_img_3 from "assets/img/Main Images/Home/ghar360.webp";
import vision_img_4 from "assets/img/Main Images/Home/best digital marketing services india.jpg";
import vision_img_5 from "assets/img/Main Images/Home/Ar_interactive_ads.webp";
import game_img from "assets/img/Main Images/2D/2D Game User interface.webp";
import { NavItem, TabItem } from "./politician-vision";
import data from "data/home-data.json";
import YouTubeInView, { ARRISE_DEMO_VIDEO_ID, GHAR360_DEMO_VIDEO_ID } from "components/common/youtube-in-view";

const ServicesVision = () => {
  const [Items, setItems] = useState("four-tab");
  const ambientRef = useRef(null);
  const handleItems = async (e) => {
    setItems(e.currentTarget.id);
  };
  const handleAmbientMove = (event) => {
    if (!ambientRef.current) return;

    ambientRef.current.querySelectorAll("[data-repel]").forEach((element) => {
      const rect = element.getBoundingClientRect();
      const elementX = rect.left + rect.width / 2;
      const elementY = rect.top + rect.height / 2;
      const distanceX = elementX - event.clientX;
      const distanceY = elementY - event.clientY;
      const distance = Math.hypot(distanceX, distanceY);
      const radius = 210;

      if (distance < radius) {
        const strength = (radius - distance) / radius;
        const pushX = (distanceX / Math.max(distance, 1)) * strength * 42;
        const pushY = (distanceY / Math.max(distance, 1)) * strength * 42;

        element.style.setProperty("--repel-x", `${pushX}px`);
        element.style.setProperty("--repel-y", `${pushY}px`);
        element.classList.add("is-repelling");
      } else {
        element.style.setProperty("--repel-x", "0px");
        element.style.setProperty("--repel-y", "0px");
        element.classList.remove("is-repelling");
      }
    });
  };
  const handleAmbientLeave = () => {
    if (!ambientRef.current) return;

    ambientRef.current.querySelectorAll("[data-repel]").forEach((element) => {
      element.style.setProperty("--repel-x", "0px");
      element.style.setProperty("--repel-y", "0px");
      element.classList.remove("is-repelling");
    });
  };
  return (
    <>
      <section
        className="vision__area vision__style-2 pt-110 pb-110 grey-bg-4"
        onMouseMove={handleAmbientMove}
        onMouseLeave={handleAmbientLeave}
      >
        <div className="vision__ambient" aria-hidden="true" ref={ambientRef}>
          <span className="vision__ambient-orbit vision__ambient-orbit--one" data-repel></span>
          <span className="vision__ambient-orbit vision__ambient-orbit--two" data-repel></span>
          <span className="vision__ambient-chip vision__ambient-chip--one" data-repel>Ghar360</span>
          <span className="vision__ambient-chip vision__ambient-chip--two" data-repel>AR</span>
          <span className="vision__ambient-chip vision__ambient-chip--three" data-repel>3D</span>
          <span className="vision__ambient-spark vision__ambient-spark--one" data-repel></span>
          <span className="vision__ambient-spark vision__ambient-spark--two" data-repel></span>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-xxl-8 col-xl-9 col-lg-10">
              <div className="tp-section-wrapper-2 mb-60">
                <span className="tp-section-subtitle-2"></span>
                <h3 className="tp-section-title-2">
                  {data?.home.service?.title}
                  {/* Our various types of services especially for you */}
                </h3>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-5">
              <div className="vision__tab tp-tab">
                <ul
                  className="nav nav-tabs flex-column"
                  id="visionTab"
                  role="tablist"
                >
                  <NavItem
                    delay=".1s"
                    id="four"
                    icon={<i class="fi fi-br-home"></i>}
                    title="Ghar360"
                    active={Items === "four-tab"}
                    onClick={handleItems}
                  />
                  <NavItem
                    delay=".2s"
                    id="five"
                    icon={<i class="fi fi-rr-cube"></i>}
                    title="AR-Rise"
                    active={Items === "five-tab"}
                    onClick={handleItems}
                  />
                  <li
                    className="vision__tab-divider"
                    role="presentation"
                    aria-hidden="true"
                  ></li>
                  <NavItem
                    delay=".3s"
                    id="one"
                    active={Items === "one-tab"}
                    icon={<i class="fi fi-rr-cubes"></i>}
                    title="3D Service"
                    onClick={handleItems}
                  />
                  <NavItem
                    delay=".5s"
                    active={Items === "two-tab"}
                    id="two"
                    onClick={handleItems}
                    icon={<i class="fi fi-rr-pencil-paintbrush"></i>}
                    title="2D Service"
                  />
                  <NavItem
                    delay=".7s"
                    id="three"
                    icon={<i class="fi fi-br-hastag"></i>}
                    title="Digital Marketing"
                    active={Items === "three-tab"}
                    onClick={handleItems}
                  />
                  <NavItem
                    delay=".9s"
                    id="game"
                    icon={<i class="fi fi-rr-gamepad"></i>}
                    title="Game Development"
                    active={Items === "game-tab"}
                    onClick={handleItems}
                  />
                </ul>
              </div>
            </div>

            <div className="col-xxl-9 col-xl-8 col-lg-8 col-md-7">
              <div className="vision__tab-content pl-70">
                <div className="tab-content" id="visionTabContent">
                  <TabItem
                    id="four"
                    active={Items === "four-tab"}
                    img={vision_img_3}
                    media={
                      <YouTubeInView
                        className="vision__video"
                        videoId={GHAR360_DEMO_VIDEO_ID}
                        poster={vision_img_3}
                        title="Ghar360 interactive property walkthrough demo"
                      />
                    }
                    desc="Ghar360 creates interactive property walkthrough experiences that help buyers, builders, and real estate teams explore spaces with clarity and confidence."
                    lists={{
                      "Know more": "/ghar360",
                    }}
                  />
                  <TabItem
                    id="five"
                    active={Items === "five-tab"}
                    img={vision_img_5}
                    media={
                      <YouTubeInView
                        className="vision__video"
                        videoId={ARRISE_DEMO_VIDEO_ID}
                        poster={vision_img_5}
                        title="ARRISE AR experience demo"
                      />
                    }
                    desc="AR-Rise builds immersive AR engagements that bring products, spaces, and brand experiences into the real world through interactive technology."
                    lists={{
                      "Know more": "/arrise",
                    }}
                  />
                  <TabItem
                    id="one"
                    active={Items === "one-tab"}
                    img={vision_img_1}
                    desc="We specialize in offering best 3D modeling, best 3D animation, texturing, product presentation, and 3D mockup services across the industries. "
                    lists={{
                      // "Customized models": "/link",

                      // "High quality models": "",
                      "Know more": "/best-3d-services-india",
                    }}
                  />
                  <TabItem
                    active={Items === "two-tab"}
                    id="two"
                    img={vision_img_2}
                    desc="We provide 2D art and animation services in Delhi of various scopes to suit your business needs, from graphic designing to motion graphics and video presentation. "
                    lists={{
                      // "Conceptual and creative designs",
                      // "Helps in brand building",
                      "Know more": "/graphic-designing-services-india",
                    }}
                  />
                  <TabItem
                    id="three"
                    active={Items === "three-tab"}
                    img={vision_img_4}
                    desc="We offer the best digital marketing services in India to startups and various businesses. Our digital marketing experts will help you expand your business to reach new heights."
                    lists={
                      //   [
                      //   "Promote greater consumer engagement",
                      //   "Build your brand reputation across online channels",
                      // ]
                      {
                        "Know more": "/best-digital-marketing-services-india",
                      }
                    }
                  />
                  <TabItem
                    id="game"
                    active={Items === "game-tab"}
                    img={game_img}
                    desc="We develop engaging 2D and 3D mobile games in Unity, covering game design, gameplay programming, UI, optimization, testing, and launch support."
                    lists={{
                      "Know more": "/game-development-services-india",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ServicesVision;
